
import { Box, Icon, SimpleGrid, useColorModeValue } from "@chakra-ui/react";

import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import WeeklyExpense from "./components/WeeklyExpense";
import { fetchAsyncGetExpenseBarChartData } from "redux/OrganizationExpenseSlice";
import { generateYearOptions } from "../default/components/filterOption";
import { fetchAsyncGetInvoiceBarChartData } from "redux/salesInvoice";

const {defaultSelected} = generateYearOptions();

export default function ExpenseReports({name, type,moduleType, icon,heading,moduleId,expenseType}) {
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  const dispatch = useDispatch();
  const [expensTotalPayAmount, setExpenseTotalPayAmount] =
    useState(null);
  
  
  const [optionBarChart, setOptionsBarChart] = useState([]);
  const [valuesBarChart, setValuesBarChart] = useState([]);

  const [selectExpYear, setSelectExpYear] = useState(defaultSelected);
  const selectExpType = type;
  const defaultObj = {
    viewType:"monthly",
    officeId:"",
    majorId:"",
    minorId:"",
    minorSubCategoryId:"",
    merchantId:"",
    clientId:"",
    resourceId:"",
    referenceResourcePO:"",
    receiverId:"",
    projectId:""
  }
  const [selectFilterData, setSelectFilterData] = useState(defaultObj)

  const handleFilterData = (obj)=>{
    const name = obj?.name;;
    const id = obj?.id;

    if(name === "clientId" && id === ""){
      setSelectFilterData({
        ...selectFilterData,
        projectId:""
      })
    }
    if (name === 'majorId' && selectFilterData[name] !== id) {
      setSelectFilterData({
        ...selectFilterData,
        majorId:id,
        minorId:"",
        minorSubCategoryId:""
      });
    } else if (name === 'minorId' && selectFilterData[name] !== id) {
      setSelectFilterData({
        ...selectFilterData,
        minorId:id,
        minorSubCategoryId:""
      });
    } else {
      setSelectFilterData({
        ...selectFilterData,
        [name]: id
      });
    }
   
  }

  const handleReset = (e)=>{
    e?.preventDefault()
    setSelectFilterData(defaultObj)
  }
  const handleFilterType = (e)=>{
    const name = e?.target?.name;
    const value = e?.target?.value;
    setSelectFilterData({
      ...selectFilterData,
      [name]: value
    });
  }

  const { addToast } = useToasts();

  const fetchFinancialYearExpense = () => {
    const startYear = selectExpYear.split("-")[0];
    const endYear = selectExpYear.split("-")[1];
  
    const fetchExpenseData = (action) => {
      dispatch(action).then((res) => {
        if (res.payload) {
          let options = [];
          let values = [];
  
          if (Array.isArray(res.payload?.formattedResult)) {
            options = res.payload?.formattedResult.map((data) => Object.keys(data)[0]);
            values = res.payload?.formattedResult.map((data) => Object.values(data)[0]);
          } else if (typeof res.payload?.formattedResult === 'object') {
            options = Object.keys(res.payload?.formattedResult);
            values = Object.values(res.payload?.formattedResult);
          } else {
            addToast(res.error?.message, { appearance: "error" });
            return;
          }
  
          setOptionsBarChart(options);
          setValuesBarChart(values);
          setExpenseTotalPayAmount(res.payload?.totalAmount || 0)

        } else {
          addToast(res.error?.message, { appearance: "error" });
        }
      });
    };
  
        fetchExpenseData(
          fetchAsyncGetExpenseBarChartData({
            expense: selectExpType,
            moduleId:moduleId || null,
            filterOption: selectFilterData,
            startDate: startYear,
            endDate: endYear,
          })
        );
   
  };
  
  const fetchFinancialYearSalesInvoice = () => {
    const startYear = selectExpYear.split("-")[0];
    const endYear = selectExpYear.split("-")[1];
  
    const fetchExpenseData = (action) => {
      dispatch(action).then((res) => {
        if (res.payload) {
          let options = [];
          let values = [];
  
          if (Array.isArray(res.payload?.formattedResult)) {
            options = res.payload?.formattedResult.map((data) => Object.keys(data)[0]);
            values = res.payload?.formattedResult.map((data) => Object.values(data)[0]);
          } else if (typeof res.payload?.formattedResult === 'object') {
            options = Object.keys(res.payload?.formattedResult);
            values = Object.values(res.payload?.formattedResult);
          } else {
            addToast(res.error?.message, { appearance: "error" });
            return;
          }
  
          setOptionsBarChart(options);
          setValuesBarChart(values);
          setExpenseTotalPayAmount(res.payload?.totalAmount || 0)

        } else {
          addToast(res.error?.message, { appearance: "error" });
        }
      });
    };
  
        fetchExpenseData(
          fetchAsyncGetInvoiceBarChartData({
            moduleId:moduleId || null,
            filterOption: selectFilterData,
            startDate: startYear,
            endDate: endYear,
          })
        );
   
  };
  useEffect(() => {
    if(expenseType !== 'SalesInvoice'){
      fetchFinancialYearExpense();
    }
    else{
      fetchFinancialYearSalesInvoice()
    }
  }, [selectExpYear, selectExpType, selectFilterData,expenseType]);

 
  

  return (
    <>
    
    <Box className="mx-2" >
      <SimpleGrid
        columns={{ base: 1, md: 1, lg: 2, "2xl": 3 }}
        gap="20px"
        mb="20px"
        className="grid-amount mt-5"

      
      >
        <MiniStatistics
          startContent={
            <IconBox
              w="46px"
              h="46px"
              bg={boxBg}
              icon={icon}
            />
          }
          name={name}
          value={expensTotalPayAmount ? formatAmountInINR(expensTotalPayAmount) : formatAmountInINR(0)}
        />
      </SimpleGrid>
    
      <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap="20px" mb="20px">
        {/* <TotalSpent /> */}
        {optionBarChart.length > 0 && valuesBarChart.length > 0 && (
          <>
          <WeeklyExpense
            optionBarChart={optionBarChart}
            valuesBarChart={valuesBarChart}
            type={selectExpType}
            changeYear={(value) => {
              setSelectExpYear(value);
            }}
            handleFilter = {(e)=>{
              handleFilterData(e)
            }}
            handleFilterViewType={(e)=>handleFilterType(e)}
            filterData = {selectFilterData}
            heading = {heading}
            selectExpYear={selectExpYear}
            handleReset = {(e)=>handleReset(e)}
            moduleType={moduleType}
            expenseType={expenseType}
          />
          
          </>
        )}
       
      </SimpleGrid>
    </Box>
    </>
  );
}
